import React, { useEffect, useState } from 'react'
import { Checkbox } from 'antd';

//列类型筛选
export default function MyCheckBox({ optionData, checkCallback }) {
    const [options, setOptions] = useState([])
    const [boxData, setBoxData] = useState([])

    const onChange = (v) => {
        //最少保留一列
        if (v.length > 0) {
            setBoxData([...v]);
            checkCallback(v);
        }
    }
    //加载各个属性渲染成多选框
    useEffect(() => {
        console.log(optionData);
        let arr = [], darr = []
        for (let i = 0; i < optionData.length; i++) {
            if (optionData[i].title) {
                arr.push({
                    label: optionData[i].title,
                    value: optionData[i].dataIndex,
                });
                darr.push(optionData[i].dataIndex)
            }
        }
        setOptions(arr)
        setBoxData(darr)
    }, []);

    return (
        <div style={{ margin: '5px' }}>
            <Checkbox.Group options={options} defaultValue={boxData} onChange={onChange} value={boxData} />
        </div>
    )
}

